'use client'

import { useState, useEffect } from 'react'
import BecomeAMentorHero from './BecomeAMentorHero'
import { UserWithMentor } from '@/types/mentor'

export default function BecomeAMentorHeroWrapper() {
  const [floatingMentors, setFloatingMentors] = useState<UserWithMentor[]>([])
  
  useEffect(() => {
    fetch('/api/mentors?limit=12')
      .then(res => res.json())
      .then(data => setFloatingMentors(data))
      .catch(err => console.error('Failed to load mentors:', err))
  }, [])
  
  return <BecomeAMentorHero floatingMentors={floatingMentors} />
}
